export const queryKeys = {
  api: {
    withAuth: ["api", "with-auth"] as const,
  },
} as const;
